import React, { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const MoveEightVertical: FC<IconProps> = ({ width = 30, height = 30, fill = '#F7F7F7', className }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="30" height="30" rx="6" />
      <path
        d="M15 26.25C11.67 26.25 9.25 24.05 9.25 20.75C9.25 18.72 10.35 16.99 12.7 15C10.35 13.01 9.25 11.28 9.25 9.25C9.25 5.95 11.67 3.75 15 3.75C18.33 3.75 20.75 5.95 20.75 9.25C20.75 11.28 19.65 13.01 17.3 15C19.65 16.99 20.75 18.72 20.75 20.75C20.75 24.05 18.33 26.25 15 26.25ZM15 16C12.43 17.96 10.75 19.32 10.75 20.75C10.75 23.17 12.43 24.75 15 24.75C17.57 24.75 19.25 23.17 19.25 20.75C19.25 19.32 17.57 17.96 15 16ZM15 5.25C12.43 5.25 10.75 6.83 10.75 9.25C10.75 10.68 12.43 12.04 15 14C17.57 12.04 19.25 10.68 19.25 9.25C19.25 6.83 17.57 5.25 15 5.25Z"
        fill={fill}
      />
    </svg>
  );
};
